import { api } from '@/utils/api';

type UncheckedCountResponse = {
  code: string;
  count: number;
};

// 라운지 api에서 문제 발생해도 파트너센터는 동작하도록 별도로 에러 처리
export const getUncheckedCount = async () => {
  try {
    return await api<UncheckedCountResponse>('get', `/api/public/bulletin/uncheckedCount`, {
      serviceType: 'KAKAOWALLET'
    });
  } catch {
    return undefined;
  }
};
